import grid from '../../../../styles/_global/grid.json';

const BREAKPOINT = grid.w_1024.full_width;
const BREAKPOINT_MOBILE = grid.w_768.full_width;

const ACTIVE_SLIDE_CLASS = 'active';
const RESIZE_CLASS = 'resize';

const TIME_MS = 300;

const animate = ( {timing, draw, duration} ) => {
	const start = performance.now();
	
	const animateFraction = ( time ) => {
		let timeFraction = ( time - start ) / duration;
		if ( timeFraction > 1 )
		{
			timeFraction = 1;
		}
		
		const progress = timing( timeFraction );

		draw( progress );
		
		if ( timeFraction < 1 )
		{
			requestAnimationFrame( animateFraction );
		}
	};
	
	requestAnimationFrame( animateFraction );
};

const animateScroll = ( currentYOffset, diff ) => {
	animate(
		{
			duration: TIME_MS,
			timing( timeFraction )
			{
				return timeFraction;
			},
			draw( progress )
			{
				window.scrollTo(
					0,
					currentYOffset + ( diff * progress ),
				);
			},
		},
	);
};
const setContentWrapperHeightSize = ( contentWrapper ) => {
	if ( !contentWrapper )
	{
		return;
	}

	const contentHeight = Array.from( contentWrapper.children ).map( ( child ) => child.offsetHeight ).reduce( ( result, height ) => result + height, 0 );

	contentWrapper.style.setProperty( 'height', `${contentHeight}px` );
};

const setContentWrapperHeight = ( contentWrapper ) => {
	if ( !contentWrapper )
	{
		return;
	}

	setContentWrapperHeightSize( contentWrapper );

	setTimeout( () => {
		contentWrapper.style.setProperty( 'height', 'auto' );
	}, TIME_MS + 50 );
};

const initSectionAccordion = () => {
	document.querySelectorAll( 'section.accordion' ).forEach( ( component ) => {
		const header = document.querySelector( 'body > header' );
		const slidesWrapper = component.querySelector( 'ul.slides' );

		if ( !slidesWrapper )
		{
			return;
		}

		slidesWrapper.classList.add( RESIZE_CLASS );

		slidesWrapper.addEventListener( 'click', ( evt ) => {
			const label = evt.target.closest( 'div.label-wrapper' );

			if ( !label )
			{
				return;
			}

			const slide = label.closest( 'li' );

			if ( !slide )
			{
				return;
			}

			const contentWrapper = slide.querySelector( 'div.content-wrapper' );

			slidesWrapper.classList.remove( RESIZE_CLASS );

			slidesWrapper.querySelectorAll( `li.${ACTIVE_SLIDE_CLASS}` ).forEach( ( activeSlide ) => {
				activeSlide.classList.remove( ACTIVE_SLIDE_CLASS );

				if ( window.innerWidth < BREAKPOINT )
				{
					const activeContentWrapper = activeSlide.querySelector( 'div.content-wrapper' );

					if ( activeContentWrapper )
					{
						setContentWrapperHeightSize( activeContentWrapper );

						setTimeout( () => {
							activeContentWrapper.style.removeProperty( 'height' );
						}, 10 );
					}
				}
			} );

			slide.classList.add( ACTIVE_SLIDE_CLASS );

			if ( window.innerWidth < BREAKPOINT )
			{
				const slidesOffset = slidesWrapper.getBoundingClientRect().y;

				if ( slidesOffset < 0 )
				{
					let topOffset = 20;
	
					if ( header && window.innerWidth < BREAKPOINT_MOBILE )
					{
						topOffset += header.offsetHeight;
					}

					const diff = slidesOffset - topOffset;

					animateScroll( window.pageYOffset, diff );
				}

				setContentWrapperHeight( contentWrapper );
			}
		} );

		const handleResize = () => {
			slidesWrapper.classList.add( RESIZE_CLASS );

			if ( window.innerWidth < BREAKPOINT )
			{
				const activeContentWrapper = slidesWrapper.querySelector( 'li.active div.content-wrapper' );
	
				setContentWrapperHeight( activeContentWrapper );
			}
		};

		window.addEventListener( 'resize', handleResize );
		handleResize();
	} );
};

export {
	initSectionAccordion,
};
